import { render, staticRenderFns } from "./FaqItem.vue?vue&type=template&id=1c9e09e2"
import script from "./FaqItem.vue?vue&type=script&lang=js"
export * from "./FaqItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports